import React, { useState } from "react";
import { Link } from "react-router-dom";

// Tags (menu items) with submenus
const Tags = [
  { name: "Home", link: "/" },
  {
    name: "About Us",
    link: "/about-us",
    submenu: [
      { name: "Chairman's Message", link: "/about-us/chairmans-message" },
      { name: "Vision and Mission", link: "/about-us/vision-and-mission" },
      { name: "Aim and Objective", link: "/about-us/aim-and-objective" },
      { name: "Dress Code", link: "/about-us/dress-code" },
      { name: "Discipline", link: "/about-us/discipline" },
      { name: "General Rules", link: "/about-us/general-rules" },
    ],
  },
  // { name: "Recognition", link: "/recognition" },
  {
    name: "Courses",
    link: "#",
    submenu: [
      { name: "Courses & Programmes", link: "/courses/courses-and-programmes" },
    ],
  },
  {
    name: "Academics",
    link: "#",
    submenu: [
      { name: "Admission Procedure", link: "/admission/admission-procedure" },
    ],
  },
  // { name: "Curriculum", link: "/curriculum" },
  { name: "Gallery", link: "/imagegallery" },
  { name: "Contact Us", link: "/contactus" },
  {
    name: "Login",
    // link: "",
    submenu: [
      { name: "Admin login", link: "/adminlogin" },
      { name: "Student login", link: "/studentlogin" },
    ],
  },
];

const Sidebar = ({ toggleSidebar, setToggleSidebar }) => {
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  // Toggle submenu visibility
  const handleSubMenuToggle = (index) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
  };

  // Handle menu item click
  const handleMenuItemClick = (index) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
    setToggleSidebar(false); // Close the sidebar
  };

  return (
    toggleSidebar && (
      <div className="sidebar-container">
        <ul className="sidebar-ul">
          {Tags.map((item, index) => (
            <li key={index} style={{ marginBottom: "0.5rem" }}>
              {" "}
              {/* Reduced vertical space */}
              <Link
                to={item.link}
                className="sidebar-link"
                onClick={() => {
                  if (item.submenu) {
                    handleSubMenuToggle(index);
                  } else {
                    handleMenuItemClick(index);
                  }
                }}
              >
                {item.name}
              </Link>
              {/* Render submenu if available */}
              {item.submenu && activeSubMenu === index && (
                <ul className="sidebar-submenu-ul">
                  {item.submenu.map((subItem, subIndex) => (
                    <li key={subIndex} style={{ marginBottom: "0.25rem" }}>
                      <Link
                        to={subItem.link}
                        className="sidebar-submenu-link"
                        onClick={() => handleMenuItemClick(index)}
                      >
                        {subItem.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    )
  );
};

export default Sidebar;
